// Categories
export const CATEGORIES = {
  FLIGHT: "flight",
  FLIGHT_HOME: "flight-home",
  FLIGHT_RESULT: "flight-result",
  FLIGHT_LANDING: "flight-landing",
  FLIGHT_ONE_WAY: "flight-one-way",
  FLIGHT_ROUND_TRIP: "flight-round-trip",
  FLIGHT_MULTI_CITY: "flight-multi-city",
  FLIGHT_RESERVATION: "flight-reservation",
  FLIGHT_CAMPAIGNS: "flight-campaigns",

  BUS: "bus-ticket",
  BUS_HOME: "bus-home",
  BUS_RESULT: "bus-result",
  BUS_LANDING: "bus-landing",
  BUS_ONE_WAY: "bus-one-way",
  BUS_RESERVATION: "bus-reservation",

  FERRY: "ferry",
  FERRY_HOME: "ferry-home",
  FERRY_RESULT: "ferry-result",
  FERRY_LANDING: "ferry-landing",
  FERRY_ONE_WAY: "ferry-one-way",
  FERRY_ROUND_TRIP: "ferry-round-trip",
  FERRY_RESERVATION: "ferry-reservation",

  CAR: "car-rental",
  CAR_HOME: "car-rental-home",
  CAR_RESULT: "car-rental-result",
  CAR_LANDING: "car-rental-landing",
  CAR_RESERVATION: "car-rental-reservation",
  CAR_NOTFOUND: "car-rental-not-found",

  HOTEL: "hotel",
  HOTEL_HOME: "hotel-home",
  HOTEL_DETAIL: "hotel-detail",
  HOTEL_RESULT: "hotel-result",
  HOTEL_LANDING: "hotel-landing",
  HOTEL_RESERVATION: "hotel-reservation",

  HOME: "home",
  LANDING: "landing",
  CORE: "core",
  RESERVATION: "reservation",
  PAYMENT: "payment",
  ACCOUNT: "account",
  HIDE_FOOTER: "hide-footer",
  BLURRY_HEADER: "blurry-header",
  HIDDEN_NAVBAR: "hidden-navbar",
  RESERVATION_DETAIL: "reservation-detail",
};

// Base paths
export const PATHS = {
  // Home
  HOME: {
    PATH: "/",
    CATEGORIES: [
      CATEGORIES.HOME,
      CATEGORIES.CORE,
      CATEGORIES.BLURRY_HEADER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },

  // Flight
  FLIGHT_TICKET: {
    PATH: "/flight",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.FLIGHT_HOME,
      CATEGORIES.BLURRY_HEADER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  FLIGHT_TICKET_COMPLETE: {
    PATH: "/shopping/finish-reservation/[hashCode]",
    CATEGORIES: [CATEGORIES.FLIGHT],
  },
  FLIGHT_TICKET_ONE_WAY: {
    PATH: "/flight/one-way/[airportInfo]/[departureDate]",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.FLIGHT_RESULT,
      CATEGORIES.FLIGHT_ONE_WAY,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  FLIGHT_TICKET_ROUND_TRIP: {
    PATH: "/flight/round-trip/[airportInfo]/[departureDate]/[returnDate]",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.FLIGHT_RESULT,
      CATEGORIES.FLIGHT_ROUND_TRIP,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  FLIGHT_TICKET_MULTI_CITY: {
    PATH: "/flight/multi-city/[...segments]",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.FLIGHT_RESULT,
      CATEGORIES.FLIGHT_MULTI_CITY,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  FLIGHT_TICKET_LANDING: {
    PATH: "/flight/[landingPageName]",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.FLIGHT_LANDING,
      CATEGORIES.LANDING,
      CATEGORIES.BLURRY_HEADER,
    ],
  },
  FLIGHT_TICKET_CAMPAIGNS: {
    PATH: "/flight/campaigns",
    CATEGORIES: [CATEGORIES.FLIGHT, CATEGORIES.FLIGHT_CAMPAIGNS],
  },
  FLIGHT_TICKET_RESERVATION: {
    PATH: "/flight/reservation/[reservationId]",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.FLIGHT_RESERVATION,
      CATEGORIES.RESERVATION,
      CATEGORIES.HIDE_FOOTER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  FLIGHT_INTERNATIONAL_TICKET_ROOT: {
    PATH: "/flight-international-ticket",
    CATEGORIES: [CATEGORIES.FLIGHT, CATEGORIES.CORE],
  },
  FLIGHT_DOMESTIC_TICKET_ROOT: {
    PATH: "/flight-domestic-ticket",
    CATEGORIES: [CATEGORIES.FLIGHT, CATEGORIES.CORE],
  },
  FLIGHT_AIRLINES_ROOT: {
    PATH: "/flight-airlines",
    CATEGORIES: [CATEGORIES.FLIGHT, CATEGORIES.CORE],
  },
  FLIGHT_AIRPORTS_ROOT: {
    PATH: "/flight-airports",
    CATEGORIES: [CATEGORIES.FLIGHT, CATEGORIES.CORE],
  },

  // Bus
  BUS_TICKET: {
    PATH: "/bus-ticket",
    CATEGORIES: [
      CATEGORIES.BUS,
      CATEGORIES.BUS_HOME,
      CATEGORIES.BLURRY_HEADER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  BUS_COMPANIES: {
    PATH: "/bus-ticket/bus-companies",
    CATEGORIES: [CATEGORIES.BUS, CATEGORIES.CORE],
  },
  BUS_TERMINALS: {
    PATH: "/bus-ticket/bus-terminals",
    CATEGORIES: [CATEGORIES.BUS, CATEGORIES.CORE],
  },
  BUS_TICKET_ONE_WAY_HOME: {
    PATH: "/bus-ticket/one-way/",
    CATEGORIES: [CATEGORIES.BUS, CATEGORIES.CORE],
  },
  BUS_TICKET_ONE_WAY: {
    PATH: "/bus-ticket/one-way/[stationInfo]/[departureDate]",
    CATEGORIES: [
      CATEGORIES.BUS,
      CATEGORIES.BUS_RESULT,
      CATEGORIES.BUS_ONE_WAY,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  BUS_TICKET_LANDING: {
    PATH: "/bus-ticket/[landingPageName]",
    CATEGORIES: [
      CATEGORIES.BUS,
      CATEGORIES.BUS_LANDING,
      CATEGORIES.LANDING,
      CATEGORIES.BLURRY_HEADER,
    ],
  },
  BUS_TICKET_RESERVATION: {
    PATH: "/bus-ticket/reservation/[reservationId]",
    CATEGORIES: [
      CATEGORIES.BUS,
      CATEGORIES.BUS_RESERVATION,
      CATEGORIES.RESERVATION,
      CATEGORIES.HIDE_FOOTER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },

  // Ferry
  FERRY_TICKET: {
    PATH: "/ferry",
    CATEGORIES: [
      CATEGORIES.FERRY,
      CATEGORIES.FERRY_HOME,
      CATEGORIES.BLURRY_HEADER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  FERRY_TICKET_ONE_WAY: {
    PATH: "/ferry/one-way/[stationInfo]/[departureDate]",
    CATEGORIES: [
      CATEGORIES.FERRY,
      CATEGORIES.FERRY_RESULT,
      CATEGORIES.FERRY_ONE_WAY,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  FERRY_TICKET_ROUND_TRIP: {
    PATH: "/ferry/round-trip/[stationInfo]/[departureDate]/[returnDate]",
    CATEGORIES: [
      CATEGORIES.FERRY,
      CATEGORIES.FERRY_RESULT,
      CATEGORIES.FERRY_ROUND_TRIP,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  FERRY_TICKET_RESERVATION: {
    PATH: "/ferry/reservation/[reservationId]",
    CATEGORIES: [
      CATEGORIES.FERRY,
      CATEGORIES.FERRY_RESERVATION,
      CATEGORIES.RESERVATION,
      CATEGORIES.HIDE_FOOTER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  FERRY_TICKET_LANDING: {
    PATH: "/ferry/[landingPageName]",
    CATEGORIES: [
      CATEGORIES.FERRY,
      CATEGORIES.FERRY_LANDING,
      CATEGORIES.LANDING,
      CATEGORIES.BLURRY_HEADER,
    ],
  },
  FERRY_COMPANIES: {
    PATH: "/ferry/ferry-companies",
    CATEGORIES: [CATEGORIES.FERRY, CATEGORIES.CORE],
  },
  FERRY_GREEK_ISLANDS: {
    PATH: "/ferry/greek-islands",
    CATEGORIES: [CATEGORIES.FERRY, CATEGORIES.CORE],
  },
  FERRY_CYPRUS: {
    PATH: "/ferry/cyprus",
    CATEGORIES: [CATEGORIES.FERRY, CATEGORIES.CORE],
  },

  // Hotel
  HOTEL: {
    PATH: "/hotel",
    CATEGORIES: [
      CATEGORIES.HOTEL,
      CATEGORIES.HOTEL_HOME,
      CATEGORIES.BLURRY_HEADER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  HOTEL_LANDING: {
    PATH: "/hotel/[landingPageName]",
    CATEGORIES: [
      CATEGORIES.HOTEL,
      CATEGORIES.HOTEL_LANDING,
      CATEGORIES.LANDING,
      CATEGORIES.BLURRY_HEADER,
    ],
  },
  HOTEL_SEARCH: {
    PATH: "/hotel/search/[hotelName]/[checkinDate]/[checkOutDate]",
    CATEGORIES: [
      CATEGORIES.HOTEL,
      CATEGORIES.HOTEL_RESULT,

      CATEGORIES.HIDE_FOOTER,
    ],
  },
  HOTEL_ABROAD: {
    PATH: "/hotel/abroad-hotels",
    CATEGORIES: [CATEGORIES.HOTEL, CATEGORIES.CORE],
  },
  HOTEL_Detail: {
    PATH: "/hotel/detail/[hotelName]/[checkinDate]/[checkOutDate]",
    CATEGORIES: [CATEGORIES.HOTEL, CATEGORIES.HOTEL_DETAIL],
  },
  HOTEL_RESERVATION: {
    PATH: "/hotel/reservation/[reservationId]",
    CATEGORIES: [
      CATEGORIES.HOTEL,
      CATEGORIES.HOTEL_RESERVATION,
      CATEGORIES.RESERVATION,
      CATEGORIES.HIDE_FOOTER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },

  // Car Rental
  CAR_RENTAL: {
    PATH: "/car-rental",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.CAR_HOME,
      CATEGORIES.BLURRY_HEADER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  CAR_RENTAL_SEARCH: {
    PATH: "/car-rental/search/[location]/[dates]",
    CATEGORIES: [CATEGORIES.CAR, CATEGORIES.CAR_RESULT, CATEGORIES.HIDE_FOOTER],
  },
  CAR_RENTAL_RESERVATION: {
    PATH: "/car-rental/reservation/[cartId]",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.CAR_RESERVATION,
      CATEGORIES.RESERVATION,
      CATEGORIES.HIDDEN_NAVBAR,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  CAR_RENTAL_LANDING_CITY: {
    PATH: "/car-rental/city/[slug]",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.CAR_LANDING,
      CATEGORIES.LANDING,

      CATEGORIES.BLURRY_HEADER,
    ],
  },
  CAR_RENTAL_LANDING_DISTRICT: {
    PATH: "/car-rental/district/[slug]",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.CAR_LANDING,
      CATEGORIES.LANDING,

      CATEGORIES.BLURRY_HEADER,
    ],
  },
  CAR_RENTAL_LANDING_AIRPORT: {
    PATH: "/car-rental/airport/[slug]",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.CAR_LANDING,
      CATEGORIES.LANDING,

      CATEGORIES.BLURRY_HEADER,
    ],
  },
  CAR_RENTAL_LANDING_COMPANY_LIST: {
    PATH: "/car-rental/company",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.CAR_LANDING,
      CATEGORIES.LANDING,

      CATEGORIES.BLURRY_HEADER,
    ],
  },
  CAR_RENTAL_LANDING_COMPANY_DETAIL: {
    PATH: "/car-rental/company/[slug]",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.CAR_LANDING,
      CATEGORIES.LANDING,

      CATEGORIES.BLURRY_HEADER,
    ],
  },
  CAR_RENTAL_NOT_FOUND: {
    PATH: "/car-rental/[...slug]",
    CATEGORIES: [CATEGORIES.CAR],
  },

  // Payment
  PAYMENT: {
    PATH: "/payment/[cartId]",
    CATEGORIES: [
      CATEGORIES.PAYMENT,
      CATEGORIES.HIDE_FOOTER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },
  PAYMENT_COMPLETED: {
    PATH: "/payment/completed/[cartId]",
    CATEGORIES: [
      CATEGORIES.PAYMENT,
      CATEGORIES.HIDE_FOOTER,
      CATEGORIES.HIDDEN_NAVBAR,
    ],
  },

  // Reservation
  RESERVATION: {
    PATH: "/reservation/[hashCode]",
    CATEGORIES: [
      CATEGORIES.RESERVATION_DETAIL,
      CATEGORIES.CORE,
      CATEGORIES.HIDE_FOOTER,
      //
    ],
  },
  RESERVATION_CANCEL_BUS: {
    PATH: "/reservation/cancel/bus/[hashCode]",
    CATEGORIES: [
      CATEGORIES.BUS,
      CATEGORIES.RESERVATION_DETAIL,
      CATEGORIES.CORE,
    ],
  },
  RESERVATION_CANCEL_FLIGHT: {
    PATH: "/reservation/cancel/flight/[hashCode]",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.RESERVATION_DETAIL,
      CATEGORIES.CORE,
    ],
  },
  RESERVATION_CANCEL_FERRY: {
    PATH: "/reservation/cancel/ferry/[hashCode]",
    CATEGORIES: [
      CATEGORIES.FERRY,
      CATEGORIES.RESERVATION_DETAIL,
      CATEGORIES.CORE,
    ],
  },
  RESERVATION_CANCEL_HOTEL: {
    PATH: "/reservation/cancel/hotel/[hashCode]",
    CATEGORIES: [
      CATEGORIES.HOTEL,
      CATEGORIES.RESERVATION_DETAIL,
      CATEGORIES.CORE,
    ],
  },
  RESERVATION_CANCEL_CAR: {
    PATH: "/reservation/cancel/car/[hashCode]",
    CATEGORIES: [
      CATEGORIES.CAR,
      CATEGORIES.RESERVATION_DETAIL,
      CATEGORIES.CORE,
    ],
  },
  RESERVATION_REISSUE_FLIGHT: {
    PATH: "/reservation/reissue/flight/[hashCode]",
    CATEGORIES: [
      CATEGORIES.FLIGHT,
      CATEGORIES.RESERVATION_DETAIL,
      CATEGORIES.CORE,
    ],
  },
  RESERVATION_WITH_ID: {
    PATH: "/reservation/[reservationId]",
    CATEGORIES: [CATEGORIES.RESERVATION_DETAIL, CATEGORIES.CORE],
  },

  // Account Pages
  PROFILE_PAGE: {
    PATH: "/account/profile",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  SAVED_CARDS_PAGE: {
    PATH: "/account/saved-cards",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  PASSENGERS_PAGE: {
    PATH: "/account/passengers",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  PRICE_ALARMS_PAGE: {
    PATH: "/account/price-alarms",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  POINT_DETAILS_PAGE: {
    PATH: "/account/point-details",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  INVITATION_PAGE: {
    PATH: "/account/invitations",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  INVOICE_PAGE: {
    PATH: "/account/invoice-information",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  PROMOTIONS_PAGE: {
    PATH: "/account/promotions",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  TRAVELS_PAGE: {
    PATH: "/account/travels",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },
  TRAVELS_BUS_PAGE: {
    PATH: "/account/travels/bus",
    CATEGORIES: [
      CATEGORIES.ACCOUNT,
      CATEGORIES.BUS,
      CATEGORIES.CORE,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  TRAVELS_HOTEL_PAGE: {
    PATH: "/account/travels/hotel",
    CATEGORIES: [
      CATEGORIES.ACCOUNT,
      CATEGORIES.HOTEL,
      CATEGORIES.CORE,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  TRAVELS_CAR_PAGE: {
    PATH: "/account/travels/car",
    CATEGORIES: [
      CATEGORIES.ACCOUNT,
      CATEGORIES.CAR,
      CATEGORIES.CORE,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  TRAVELS_FERRY_PAGE: {
    PATH: "/account/travels/ferry",
    CATEGORIES: [
      CATEGORIES.ACCOUNT,
      CATEGORIES.FERRY,
      CATEGORIES.CORE,
      CATEGORIES.HIDE_FOOTER,
    ],
  },
  FAVORITES: {
    PATH: "/account/favorites",
    CATEGORIES: [CATEGORIES.ACCOUNT, CATEGORIES.CORE, CATEGORIES.HIDE_FOOTER],
  },

  // Static & Info Pages
  ABOUT_US: {
    PATH: "/about-us",
    CATEGORIES: [CATEGORIES.CORE, CATEGORIES.HIDDEN_NAVBAR],
  },
  CAMPAIGNS: {
    PATH: "/campaigns",
    CATEGORIES: [CATEGORIES.CORE],
  },
  CAMPAGINS_FLIGHT: {
    PATH: "/campaigns/flight",
    CATEGORIES: [CATEGORIES.FLIGHT, CATEGORIES.CORE],
  },
  CAMPAGINS_BUS: {
    PATH: "/campaigns/bus",
    CATEGORIES: [CATEGORIES.BUS, CATEGORIES.CORE],
  },
  CAMPAGINS_FERRY: {
    PATH: "/campaigns/ferry",
    CATEGORIES: [CATEGORIES.FERRY, CATEGORIES.CORE],
  },
  CAMPAGINS_HOTEL: {
    PATH: "/campaigns/hotel",
    CATEGORIES: [CATEGORIES.HOTEL, CATEGORIES.CORE],
  },
  CAMPAGINS_CAR: {
    PATH: "/campaigns/car",
    CATEGORIES: [CATEGORIES.CAR, CATEGORIES.CORE],
  },
  CAMPAGINS_DETAIL: {
    PATH: "/campaigns/[campaignSlug]",
    CATEGORIES: [CATEGORIES.CORE],
  },
  POINT_CONVERT: {
    PATH: "/credit-card-points",
    CATEGORIES: [CATEGORIES.CORE],
  },
  API_SERVICE: {
    PATH: "/turna-api-service",
    CATEGORIES: [CATEGORIES.CORE],
  },
  CONTACT: {
    PATH: "/contact",
    CATEGORIES: [CATEGORIES.CORE],
  },
  PRIVACY_POLICY: {
    PATH: "/privacy-policy",
    CATEGORIES: [CATEGORIES.CORE],
  },
  SOCIAL_MEDIA_PERMISSIONS: {
    PATH: "/social-media-permissions",
    CATEGORIES: [CATEGORIES.CORE],
  },
  COOKIE_POLICY: {
    PATH: "/cookie-policy",
    CATEGORIES: [CATEGORIES.CORE],
  },
  TERMS_OF_USE: {
    PATH: "/terms-of-service",
    CATEGORIES: [CATEGORIES.CORE],
  },
  DATA_PROTECTION: {
    PATH: "/protection-of-personal-data",
    CATEGORIES: [CATEGORIES.CORE],
  },
  COMMERCIAL_MESSAGE_CONSENT: {
    PATH: "/electronic-message-policy",
    CATEGORIES: [CATEGORIES.CORE],
  },
  GUIDELINE: {
    PATH: "/guideline",
    CATEGORIES: [CATEGORIES.CORE],
  },
  DOWNLOAD: {
    PATH: "/download",
    CATEGORIES: [CATEGORIES.CORE],
  },
  SMART_FLIGHT_TICKET: {
    PATH: "/all-services?advantage=akilli-ucus",
    CATEGORIES: [CATEGORIES.FLIGHT, CATEGORIES.CORE],
  },
  ADVANTAGES: {
    PATH: "/all-services",
    CATEGORIES: [CATEGORIES.CORE],
  },
  ONLINE_CHANGE_SERVICE: {
    PATH: "/online-change-service",
    CATEGORIES: [CATEGORIES.CORE],
  },
  UNCONDITIONAL_CANCELLATION_SERVICE: {
    PATH: "/unconditional-cancellation-service",
    CATEGORIES: [CATEGORIES.CORE],
  },
  FREE_LIVE_SUPPORT: {
    PATH: "/24-7-call-center-service",
    CATEGORIES: [CATEGORIES.CORE],
  },
  FAQ_PAGE: {
    PATH: "/frequently-asked-questions",
    CATEGORIES: [CATEGORIES.CORE],
  },
  FAQ_CATEGORY_PAGE: {
    PATH: "/frequently-asked-questions/[categorySlug]",
    CATEGORIES: [CATEGORIES.CORE],
  },

  PUBLIC_HOLIDAYS_PAGE: {
    PATH: "/public-holidays",
    CATEGORIES: [CATEGORIES.CORE],
  },
  INVITATION_REGISTER_PAGE: {
    PATH: "/invitation/[InvitationCode]",
    CATEGORIES: [CATEGORIES.CORE],
  },
  HELP_CHECK_IN: {
    PATH: "/frequently-asked-questions/check-in",
    CATEGORIES: [CATEGORIES.CORE],
  },
  HELP_BAGGAGE: {
    PATH: "/frequently-asked-questions/baggage",
    CATEGORIES: [CATEGORIES.CORE],
  },
  HELP_TICKET_CHANGE: {
    PATH: "/frequently-asked-questions/ticket-reservation-process",
    CATEGORIES: [CATEGORIES.CORE],
  },
  HELP_PASSENGER_RIGHTS: {
    PATH: "/frequently-asked-questions/passenger-rights",
    CATEGORIES: [CATEGORIES.CORE],
  },
};

export const FAQ_GUIDE_CATEGORY_SLUGS = {
  HELP_CHECK_IN: {
    tr: "check-in",
    en: "online-check-in",
    de: "online-check-in",
    ar: "online-check-in",
    az: "online-check-in",
    ru: "online-check-in",
  },
  HELP_BAGGAGE: {
    tr: "bagaj",
    en: "baggage",
    de: "baggage",
    ar: "baggage",
    az: "baggage",
    ru: "baggage",
  },
  HELP_TICKET_CHANGE: {
    tr: "bilet-rezervasyon-islemleri",
    en: "ticket-reservation-process",
    de: "ticket-reservation-process",
    ar: "ticket-reservation-process",
    az: "ticket-reservation-process",
    ru: "ticket-reservation-process",
  },
  HELP_PASSENGER_RIGHTS: {
    tr: "yolcu-haklari",
    en: "passenger-rights",
    de: "passenger-rights",
    ar: "passenger-rights",
    az: "passenger-rights",
    ru: "passenger-rights",
  },
};

export function getFaqGuideCategorySlug(key, locale = "tr") {
  return (
    FAQ_GUIDE_CATEGORY_SLUGS[key]?.[locale] || FAQ_GUIDE_CATEGORY_SLUGS[key]?.en
  );
}

// Localized paths
export const LOCALIZED_PATHS = {
  [PATHS.HOME.PATH]: PATHS.HOME.PATH,

  // Flight
  [PATHS.FLIGHT_TICKET.PATH]: {
    tr: "/ucak-bileti",
    de: "/flugticket",
    ar: "/tayaran",
    az: "/teyyare-bileti",
    ru: "/bilet-na-samolet",
  },
  [PATHS.FLIGHT_TICKET_ONE_WAY.PATH]: {
    tr: "/ucak-bileti/tek-yon/[airportInfo]/[departureDate]",
    de: "/flugticket/einweg/[airportInfo]/[departureDate]",
    ar: "/tayaran/itticah-vahid/[airportInfo]/[departureDate]",
    az: "/teyyare-bileti/bir-yonlu/[airportInfo]/[departureDate]",
    ru: "/bilet-na-samolet/odnokratnyy/[airportInfo]/[departureDate]",
  },
  [PATHS.FLIGHT_TICKET_COMPLETE.PATH]: {
    tr: "/alis-veris/rezervasyon-tamamla/[hashCode]",
    de: "/einkauf/buchung-vervollstandigen/[hashCode]",
    ar: "/altasawuq/alhajz-alkamil/[hashCode]",
    az: "/alis-veris/rezervasiya-tamamlandi/[hashCode]",
    ru: "/shopping/bronirovanie-zaversheno/[hashCode]",
  },

  [PATHS.FLIGHT_TICKET_ROUND_TRIP.PATH]: {
    tr: "/ucak-bileti/gidis-donus/[airportInfo]/[departureDate]/[returnDate]",
    de: "/flugticket/hin-und-zuruck/[airportInfo]/[departureDate]/[returnDate]",
    ar: "/tayaran/zehab-iyab/[airportInfo]/[departureDate]/[returnDate]",
    az: "/teyyare-bileti/gidis-donus/[airportInfo]/[departureDate]/[returnDate]",
    ru: "/bilet-na-samolet/dvuhratnyy/[airportInfo]/[departureDate]/[returnDate]",
  },
  [PATHS.FLIGHT_TICKET_MULTI_CITY.PATH]: {
    tr: "/ucak-bileti/coklu-ucus/[...segments]",
    de: "/flugticket/mehrfachflug/[...segments]",
    ar: "/tayaran/mutaaddid-al-mudun/[...segments]",
    az: "/teyyare-bileti/coklu-ucus/[...segments]",
    ru: "/bilet-na-samolet/mnogokratnyy/[...segments]",
  },
  [PATHS.FLIGHT_TICKET_LANDING.PATH]: {
    tr: "/ucak-bileti/[landingPageName]",
    de: "/flugticket/[landingPageName]",
    ar: "/tayaran/[landingPageName]",
    az: "/teyyare-bileti/[landingPageName]",
    ru: "/bilet-na-samolet/[landingPageName]",
  },
  [PATHS.FLIGHT_TICKET_CAMPAIGNS.PATH]: {
    tr: "/ucak-bileti/kampanyalar",
    de: "/flugticket/kampagnen",
    ar: "/tayaran/safaqat",
    az: "/teyyare-bileti/kampanyalar",
    ru: "/bilet-na-samolet/kampanii",
  },
  [PATHS.FLIGHT_TICKET_RESERVATION.PATH]: {
    tr: "/ucak-bileti/rezervasyon/[reservationId]",
    de: "/flugticket/buchung/[reservationId]",
    ar: "/tayaran/tahafaz/[reservationId]",
    az: "/teyyare-bileti/rezervasiya/[reservationId]",
    ru: "/bilet-na-samolet/bronirovaniye/[reservationId]",
  },
  [PATHS.FLIGHT_INTERNATIONAL_TICKET_ROOT.PATH]: {
    tr: "/yurtdisi-ucak-bileti",
    de: "/internationale-flugtickets",
    ar: "/tayaran-duwali",
    az: "/beynelxalq-teyyare-bileti",
    ru: "/mezhdunarodnyye-aviabilety",
  },
  [PATHS.FLIGHT_DOMESTIC_TICKET_ROOT.PATH]: {
    tr: "/ucak-seferleri",
    de: "/inlandsfluge",
    ar: "/rihlat-dakhiliya",
    az: "/daxili-ucuslar",
    ru: "/vnutrenniye-reysy",
  },
  [PATHS.FLIGHT_AIRLINES_ROOT.PATH]: {
    tr: "/ucak-firmalari",
    de: "/fluggesellschaften",
    ar: "/sharikat-tayaran",
    az: "/teyyare-sirketleri",
    ru: "/aviakompanii",
  },
  [PATHS.FLIGHT_AIRPORTS_ROOT.PATH]: {
    tr: "/havaalanlari",
    de: "/flughafen",
    ar: "/matari",
    az: "/hava-limanlari",
    ru: "/aeroporty",
  },

  // Bus
  [PATHS.BUS_TICKET.PATH]: {
    tr: "/otobus-bileti",
    en: "/bus-ticket",
    de: "/busfahrkarte",
    ar: "/tadhakir-alhafila",
    az: "/avtobus-bileti",
    ru: "/bilet-na-avtobus",
  },
  [PATHS.BUS_COMPANIES.PATH]: {
    tr: "/otobus-bileti/otobus-firmalari",
    en: "/bus-ticket/bus-companies",
    de: "/busfahrkarte/alle-busunternehmen",
    ar: "/tadhakir-alhafila/jamie-sharikat-alhafilat",
    az: "/avtobus-bileti/avtobus-sirketleri",
    ru: "/bilet-na-avtobus/avtobusnye-kompanii",
  },
  [PATHS.BUS_TERMINALS.PATH]: {
    tr: "/otobus-bileti/otogarlar",
    en: "/bus-ticket/bus-terminals",
    de: "/busfahrkarte/busbahnhof",
    ar: "/tadhakir-alhafila/mahattat-al-hafilat",
    az: "/avtobus-bileti/avtovagzallar",
    ru: "/bilet-na-avtobus/avtovokzaly",
  },
  [PATHS.BUS_TICKET_ONE_WAY_HOME.PATH]: {
    tr: "/otobus-bileti/tek-yon/",
    en: "/bus-ticket/one-way/",
    de: "/busfahrkarte/einweg/",
    ar: "/tadhakir-alhafila/itticah-vahid/",
    az: "/avtobus-bileti/bir-yonlu/",
    ru: "/bilet-na-avtobus/odnokratnyy/",
  },
  [PATHS.BUS_TICKET_ONE_WAY.PATH]: {
    tr: "/otobus-bileti/tek-yon/[stationInfo]/[departureDate]",
    en: "/bus-ticket/one-way/[stationInfo]/[departureDate]",
    de: "/busfahrkarte/einweg/[stationInfo]/[departureDate]",
    ar: "/tadhakir-alhafila/itticah-vahid/[stationInfo]/[departureDate]",
    az: "/avtobus-bileti/bir-yonlu/[stationInfo]/[departureDate]",
    ru: "/bilet-na-avtobus/odnokratnyy/[stationInfo]/[departureDate]",
  },
  [PATHS.BUS_TICKET_LANDING.PATH]: {
    tr: "/otobus-bileti/[landingPageName]",
    en: "/bus-ticket/[landingPageName]",
    de: "/busfahrkarte/[landingPageName]",
    ar: "/tadhakir-alhafila/[landingPageName]",
    az: "/avtobus-bileti/[landingPageName]",
    ru: "/bilet-na-avtobus/[landingPageName]",
  },
  [PATHS.BUS_TICKET_RESERVATION.PATH]: {
    tr: "/otobus-bileti/rezervasyon/[reservationId]",
    en: "/bus-ticket/reservation/[reservationId]",
    de: "/busfahrkarte/reservierung/[reservationId]",
    ar: "/tadhakir-alhafila/hajz/[reservationId]",
    az: "/avtobus-bileti/rezervasiya/[reservationId]",
    ru: "/bilet-na-avtobus/rezervatsiya/[reservationId]",
  },

  // Ferry
  [PATHS.FERRY_TICKET.PATH]: {
    tr: "/feribot-bileti",
    en: "/ferry",
    de: "/fahre",
    ar: "/tadhkarat-ma'diya",
    az: "/bere-bileti",
    ru: "/bilet-na-parom",
  },
  [PATHS.FERRY_TICKET_ONE_WAY.PATH]: {
    tr: "/feribot-bileti/tek-yon/[stationInfo]/[departureDate]",
    en: "/ferry/one-way/[stationInfo]/[departureDate]",
    de: "/fahre/einweg/[stationInfo]/[departureDate]",
    ar: "/tadhkarat-ma'diya/itticah-vahid/[stationInfo]/[departureDate]",
    az: "/bere-bileti/bir-yonlu/[stationInfo]/[departureDate]",
    ru: "/bilet-na-parom/odnokratnyy/[stationInfo]/[departureDate]",
  },
  [PATHS.FERRY_TICKET_ROUND_TRIP.PATH]: {
    tr: "/feribot-bileti/gidis-donus/[stationInfo]/[departureDate]/[returnDate]",
    en: "/ferry/round-trip/[stationInfo]/[departureDate]/[returnDate]",
    de: "/fahre/hin-und-zuruck/[stationInfo]/[departureDate]/[returnDate]",
    ar: "/tadhkarat-ma'diya/zehab-iyab/[stationInfo]/[departureDate]/[returnDate]",
    az: "/bere-bileti/gidis-donus/[stationInfo]/[departureDate]/[returnDate]",
    ru: "/bilet-na-parom/dvuhratnyy/[stationInfo]/[departureDate]/[returnDate]",
  },
  [PATHS.FERRY_TICKET_RESERVATION.PATH]: {
    tr: "/feribot-bileti/rezervasyon/[reservationId]",
    en: "/ferry/reservation/[reservationId]",
    de: "/fahre/reservierung/[reservationId]",
    ar: "/tadhkarat-ma'diya/hajz/[reservationId]",
    az: "/bere-bileti/rezervasiya/[reservationId]",
    ru: "/bilet-na-parom/rezervatsiya/[reservationId]",
  },
  [PATHS.FERRY_TICKET_LANDING.PATH]: {
    tr: "/feribot-bileti/[landingPageName]",
    en: "/ferry/[landingPageName]",
    de: "/fahre/[landingPageName]",
    ar: "/tadhkarat-ma'diya/[landingPageName]",
    az: "/bere-bileti/[landingPageName]",
    ru: "/bilet-na-parom/[landingPageName]",
  },
  [PATHS.FERRY_COMPANIES.PATH]: {
    tr: "/feribot-bileti/feribot-firmalari",
    en: "/ferry/ferry-companies",
    de: "/fahre/fahrgesellschaften",
    ar: "/tadhkarat-ma'diya/sharikat-ma'diya",
    az: "/bere-bileti/bere-sirketleri",
    ru: "/bilet-na-parom/paromnye-kompanii",
  },
  [PATHS.FERRY_GREEK_ISLANDS.PATH]: {
    tr: "/feribot-bileti/yunan-adalari",
    en: "/ferry/greek-islands",
    de: "/fahre/griechische-inseln",
    ar: "/tadhkarat-ma'diya/juzur-yunaniya",
    az: "/bere-bileti/yunan-adalar",
    ru: "/bilet-na-parom/grecheskiye-ostrova",
  },
  [PATHS.FERRY_CYPRUS.PATH]: {
    tr: "/feribot-bileti/kibris",
    en: "/ferry/cyprus",
    de: "/fahre/zypern",
    ar: "/tadhkarat-ma'diya/qubrus",
    az: "/bere-bileti/kipr",
    ru: "/bilet-na-parom/kipr",
  },

  // Hotel
  [PATHS.HOTEL.PATH]: {
    tr: "/otel",
    de: "/hotels",
    ar: "/alfunduq",
    az: "/otel",
    ru: "/otel",
  },
  [PATHS.HOTEL_LANDING.PATH]: {
    tr: "/otel/[landingPageName]",
    de: "/hotels/[landingPageName]",
    ar: "/alfunduq/[landingPageName]",
    az: "/otel/[landingPageName]",
    ru: "/otel/[landingPageName]",
  },
  [PATHS.HOTEL_SEARCH.PATH]: {
    tr: "/otel/ara/[hotelName]/[checkinDate]/[checkOutDate]",
    de: "/hotels/suchen/[hotelName]/[checkinDate]/[checkOutDate]",
    ar: "/alfunduq/bahth/[hotelName]/[checkinDate]/[checkOutDate]",
    az: "/otel/axtar/[hotelName]/[checkinDate]/[checkOutDate]",
    ru: "/otel/poisk/[hotelName]/[checkinDate]/[checkOutDate]",
  },
  [PATHS.HOTEL_ABROAD.PATH]: {
    tr: "/otel/yurt-disi-oteller",
    de: "/hotels/auslandshotels",
    ar: "/alfunduq/fanadiq-ajnabiya",
    az: "/otel/xarici-oteller",
    ru: "/otel/zarubezhnyye-oteli",
  },
  [PATHS.HOTEL_Detail.PATH]: {
    tr: "/otel/detay/[hotelName]/[checkinDate]/[checkOutDate]",
    de: "/hotels/detail/[hotelName]/[checkinDate]/[checkOutDate]",
    ar: "/alfunduq/tafasil/[hotelName]/[checkinDate]/[checkOutDate]",
    az: "/otel/tefsil/[hotelName]/[checkinDate]/[checkOutDate]",
    ru: "/otel/detali/[hotelName]/[checkinDate]/[checkOutDate]",
  },
  [PATHS.HOTEL_RESERVATION.PATH]: {
    tr: "/otel/rezervasyon/[reservationId]",
    de: "/hotels/reservierung/[reservationId]",
    ar: "/alfunduq/hajz/[reservationId]",
    az: "/otel/rezervasiya/[reservationId]",
    ru: "/otel/rezervatsiya/[reservationId]",
  },

  // Car Rental
  [PATHS.CAR_RENTAL.PATH]: {
    tr: "/arac-kiralama",
    de: "/autovermietung",
    ar: "/ijar-sayara",
    az: "/avtomobil-kirayesi",
    ru: "/arenda-avtomobilya",
  },
  [PATHS.CAR_RENTAL_SEARCH.PATH]: {
    tr: "/arac-kiralama/ara/[location]/[dates]",
    de: "/autovermietung/suchen/[location]/[dates]",
    ar: "/ijar-sayara/bahth/[location]/[dates]",
    az: "/avtomobil-kirayesi/axtar/[location]/[dates]",
    ru: "/arenda-avtomobilya/poisk/[location]/[dates]",
  },
  [PATHS.CAR_RENTAL_RESERVATION.PATH]: {
    tr: "/arac-kiralama/rezervasyon/[cartId]",
    de: "/autovermietung/reservierung/[cartId]",
    ar: "/ijar-sayara/hajz/[cartId]",
    az: "/avtomobil-kirayesi/rezervasiya/[cartId]",
    ru: "/arenda-avtomobilya/rezervatsiya/[cartId]",
  },
  [PATHS.CAR_RENTAL_LANDING_CITY.PATH]: {
    tr: "/arac-kiralama/sehir/[slug]",
    de: "/autovermietung/stadt/[slug]",
    ar: "/ijar-sayara/madina/[slug]",
    az: "/avtomobil-kirayesi/seher/[slug]",
    ru: "/arenda-avtomobilya/gorod/[slug]",
  },
  [PATHS.CAR_RENTAL_LANDING_DISTRICT.PATH]: {
    tr: "/arac-kiralama/ilce/[slug]",
    de: "/autovermietung/bezirk/[slug]",
    ar: "/ijar-sayara/hay/[slug]",
    az: "/avtomobil-kirayesi/rayon/[slug]",
    ru: "/arenda-avtomobilya/rayon/[slug]",
  },
  [PATHS.CAR_RENTAL_LANDING_AIRPORT.PATH]: {
    tr: "/arac-kiralama/havalimani/[slug]",
    de: "/autovermietung/flughafen/[slug]",
    ar: "/ijar-sayara/matar/[slug]",
    az: "/avtomobil-kirayesi/hava-limani/[slug]",
    ru: "/arenda-avtomobilya/aeroport/[slug]",
  },
  [PATHS.CAR_RENTAL_LANDING_COMPANY_LIST.PATH]: {
    tr: "/arac-kiralama/firma",
    de: "/autovermietung/unternehmen",
    ar: "/ijar-sayara/sharika",
    az: "/avtomobil-kirayesi/sirket",
    ru: "/arenda-avtomobilya/kompaniya",
  },
  [PATHS.CAR_RENTAL_LANDING_COMPANY_DETAIL.PATH]: {
    tr: "/arac-kiralama/firma/[slug]",
    de: "/autovermietung/unternehmen/[slug]",
    ar: "/ijar-sayara/sharika/[slug]",
    az: "/avtomobil-kirayesi/sirket/[slug]",
    ru: "/arenda-avtomobilya/kompaniya/[slug]",
  },
  [PATHS.CAR_RENTAL_NOT_FOUND.PATH]: {
    tr: "/arac-kiralama/[...slug]",
    de: "/autovermietung/[...slug]",
    ar: "/ijar-sayara/[...slug]",
    az: "/avtomobil-kirayesi/[...slug]",
    ru: "/arenda-avtomobilya/[...slug]",
  },

  // Payment
  [PATHS.PAYMENT.PATH]: {
    tr: "/odeme/[cartId]",
    de: "/zahlung/[cartId]",
    ar: "/daf/[cartId]",
    az: "/odeme/[cartId]",
    ru: "/oplata/[cartId]",
  },
  [PATHS.PAYMENT_COMPLETED.PATH]: {
    tr: "/odeme/tamamlandi/[cartId]",
    de: "/zahlung/abgeschlossen/[cartId]",
    ar: "/daf/muktamil/[cartId]",
    az: "/odeme/tamamlandi/[cartId]",
    ru: "/oplata/zavershena/[cartId]",
  },

  // Reservation
  [PATHS.RESERVATION.PATH]: {
    tr: "/rezervasyon/[hashCode]",
    de: "/reservierung/[hashCode]",
    ar: "/hajz/[hashCode]",
    az: "/rezervasiya/[hashCode]",
    ru: "/rezervatsiya/[hashCode]",
  },
  [PATHS.RESERVATION_CANCEL_BUS.PATH]: {
    tr: "/rezervasyon/iptal/otobus-bileti/[hashCode]",
    en: "/reservation/cancel/bus/[hashCode]",
    de: "/reservierung/stornierung/busfahrkarte/[hashCode]",
    ar: "/hajz/ilgha/tadhakir-alhafila/[hashCode]",
    az: "/rezervasiya/legv/avtobus-bileti/[hashCode]",
    ru: "/rezervatsiya/otmena/bilet-na-avtobus/[hashCode]",
  },
  [PATHS.RESERVATION_CANCEL_FLIGHT.PATH]: {
    tr: "/rezervasyon/iptal/ucak-bileti/[hashCode]",
    de: "/reservierung/stornierung/flugticket/[hashCode]",
    ar: "/hajz/ilgha/tayaran/[hashCode]",
    az: "/rezervasiya/legv/teyyare-bileti/[hashCode]",
    ru: "/rezervatsiya/otmena/bilet-na-samolet/[hashCode]",
  },
  [PATHS.RESERVATION_CANCEL_FERRY.PATH]: {
    tr: "/rezervasyon/iptal/feribot-bileti/[hashCode]",
    de: "/reservierung/stornierung/fahre/[hashCode]",
    ar: "/hajz/ilgha/tadhkarat-ma'diya/[hashCode]",
    az: "/rezervasiya/legv/bere-bileti/[hashCode]",
    ru: "/rezervatsiya/otmena/bilet-na-parom/[hashCode]",
  },
  [PATHS.RESERVATION_CANCEL_HOTEL.PATH]: {
    tr: "/rezervasyon/iptal/otel/[hashCode]",
    de: "/reservierung/stornierung/hotel/[hashCode]",
    ar: "/hajz/ilgha/funduq/[hashCode]",
    az: "/rezervasiya/legv/otel/[hashCode]",
    ru: "/rezervatsiya/otmena/otel/[hashCode]",
  },
  [PATHS.RESERVATION_CANCEL_CAR.PATH]: {
    tr: "/rezervasyon/iptal/arac-kiralama/[hashCode]",
    de: "/reservierung/stornierung/autovermietung/[hashCode]",
    ar: "/hajz/ilgha/ijar-sayara/[hashCode]",
    az: "/rezervasiya/legv/avtomobil-kirayesi/[hashCode]",
    ru: "/rezervatsiya/otmena/arenda-avtomobilya/[hashCode]",
  },
  [PATHS.RESERVATION_REISSUE_FLIGHT.PATH]: {
    tr: "/rezervasyon/degisiklik/ucak-bileti/[hashCode]",
    de: "/reservierung/änderung/flugticket/[hashCode]",
    ar: "/hajz/taghyir/tayaran/[hashCode]",
    az: "/rezervasiya/deyisiklik/teyyare-bileti/[hashCode]",
    ru: "/rezervatsiya/izmeneniye/bilet-na-samolet/[hashCode]",
  },
  [PATHS.RESERVATION_WITH_ID.PATH]: {
    tr: "/rezervasyon/[reservationId]",
    de: "/reservierung/[reservationId]",
    ar: "/hajz/[reservationId]",
    az: "/rezervasiya/[reservationId]",
    ru: "/rezervatsiya/[reservationId]",
  },

  // Account Pages
  [PATHS.PROFILE_PAGE.PATH]: {
    tr: "/hesabim/profil",
    de: "/konto/profil",
    ar: "/hisabi/profil",
    az: "/hesabim/profil",
    ru: "/akkaunt/profil",
  },
  [PATHS.SAVED_CARDS_PAGE.PATH]: {
    tr: "/hesabim/kayitli-kartlar",
    de: "/konto/gespeicherte-karten",
    ar: "/hisabi/bitaqat-mahfuza",
    az: "/hesabim/saxlanmis-kartlar",
    ru: "/akkaunt/sokhranennyye-karty",
  },
  [PATHS.PASSENGERS_PAGE.PATH]: {
    tr: "/hesabim/yolcularim",
    de: "/konto/passagiere",
    ar: "/hisabi/musafirun",
    az: "/hesabim/sernishinlerim",
    ru: "/akkaunt/passazhiry",
  },
  [PATHS.PRICE_ALARMS_PAGE.PATH]: {
    tr: "/hesabim/fiyat-alarmi",
    de: "/konto/preisalarm",
    ar: "/hisabi/tanbihat-si'r",
    az: "/hesabim/qiymet-siqnali",
    ru: "/akkaunt/tsenovoye-opoveshcheniye",
  },
  [PATHS.POINT_DETAILS_PAGE.PATH]: {
    tr: "/hesabim/puan-detayi",
    de: "/konto/punktedetails",
    ar: "/hisabi/tafasil-nuqat",
    az: "/hesabim/xal-tefsilleri",
    ru: "/akkaunt/detali-ballov",
  },
  [PATHS.INVITATION_PAGE.PATH]: {
    tr: "/hesabim/davetlerim",
    de: "/konto/einladungen",
    ar: "/hisabi/da'wat",
    az: "/hesabim/devet-etmelerim",
    ru: "/akkaunt/priglasheniya",
  },
  [PATHS.INVOICE_PAGE.PATH]: {
    tr: "/hesabim/fatura-bilgilerim",
    de: "/konto/rechnungsinformationen",
    ar: "/hisabi/ma'lumat-fatura",
    az: "/hesabim/fatura-melumatlarim",
    ru: "/akkaunt/dannye-schetov",
  },
  [PATHS.PROMOTIONS_PAGE.PATH]: {
    tr: "/hesabim/promosyonlar",
    de: "/konto/aktionen",
    ar: "/hisabi/tarwij",
    az: "/hesabim/promosyonlar",
    ru: "/akkaunt/aktsii",
  },
  [PATHS.TRAVELS_PAGE.PATH]: {
    tr: "/hesabim/seyahatlerim",
    de: "/konto/reisen",
    ar: "/hisabi/rihlati",
    az: "/hesabim/seferlerim",
    ru: "/akkaunt/puteshestviya",
  },
  [PATHS.TRAVELS_BUS_PAGE.PATH]: {
    tr: "/hesabim/seyahatlerim/otobus",
    en: "/account/travels/bus",
    de: "/konto/reisen/bus",
    ar: "/hisabi/rihlati/hafila",
    az: "/hesabim/seferlerim/avtobus",
    ru: "/akkaunt/puteshestviya/avtobus",
  },
  [PATHS.TRAVELS_HOTEL_PAGE.PATH]: {
    tr: "/hesabim/seyahatlerim/otel",
    de: "/konto/reisen/hotel",
    ar: "/hisabi/rihlati/funduq",
    az: "/hesabim/seferlerim/otel",
    ru: "/akkaunt/puteshestviya/otel",
  },
  [PATHS.TRAVELS_CAR_PAGE.PATH]: {
    tr: "/hesabim/seyahatlerim/arac",
    de: "/konto/reisen/auto",
    ar: "/hisabi/rihlati/sayara",
    az: "/hesabim/seferlerim/avtomobil",
    ru: "/akkaunt/puteshestviya/avtomobil",
  },
  [PATHS.TRAVELS_FERRY_PAGE.PATH]: {
    tr: "/hesabim/seyahatlerim/feribot",
    de: "/konto/reisen/fahre",
    ar: "/hisabi/rihlati/ma'diya",
    az: "/hesabim/seferlerim/bere",
    ru: "/akkaunt/puteshestviya/parom",
  },
  [PATHS.FAVORITES.PATH]: {
    tr: "/hesabim/favorilerim",
    de: "/konto/favoriten",
    ar: "/hisabi/mufaddalati",
    az: "/hesabim/sevimlilerim",
    ru: "/akkaunt/izbrannoe",
  },

  // Static & Info Pages
  [PATHS.ABOUT_US.PATH]: {
    tr: "/hakkimizda",
    de: "/uber-uns",
    ar: "/hauluna",
    az: "/haqqimizda",
    ru: "/o-nas",
  },
  [PATHS.CAMPAIGNS.PATH]: {
    tr: "/kampanyalar",
    de: "/angebote",
    ar: "/hamalat",
    az: "/kampaniyalar",
    ru: "/kampanii",
  },
  [PATHS.CAMPAGINS_FLIGHT.PATH]: {
    tr: "/kampanyalar/ucak",
    de: "/angebote/flug",
    ar: "/hamalat/tayaran",
    az: "/kampaniyalar/teyyare",
    ru: "/kampanii/samolet",
  },
  [PATHS.CAMPAGINS_BUS.PATH]: {
    tr: "/kampanyalar/otobus",
    en: "/campaigns/bus",
    de: "/angebote/bus",
    ar: "/hamalat/hafila",
    az: "/kampaniyalar/avtobus",
    ru: "/kampanii/avtobus",
  },
  [PATHS.CAMPAGINS_FERRY.PATH]: {
    tr: "/kampanyalar/feribot",
    de: "/angebote/fahre",
    ar: "/hamalat/ma'diya",
    az: "/kampaniyalar/bere",
    ru: "/kampanii/parom",
  },
  [PATHS.CAMPAGINS_HOTEL.PATH]: {
    tr: "/kampanyalar/otel",
    de: "/angebote/hotel",
    ar: "/hamalat/funduq",
    az: "/kampaniyalar/otel",
    ru: "/kampanii/otel",
  },
  [PATHS.CAMPAGINS_CAR.PATH]: {
    tr: "/kampanyalar/arac",
    de: "/angebote/auto",
    ar: "/hamalat/sayara",
    az: "/kampaniyalar/avtomobil",
    ru: "/kampanii/avtomobil",
  },
  [PATHS.CAMPAGINS_DETAIL.PATH]: {
    tr: "/kampanyalar/[campaignSlug]",
    de: "/angebote/[campaignSlug]",
    ar: "/hamalat/[campaignSlug]",
    az: "/kampaniyalar/[campaignSlug]",
    ru: "/kampanii/[campaignSlug]",
  },
  [PATHS.POINT_CONVERT.PATH]: {
    tr: "/kredi-karti-puanlari",
    de: "/kreditkartenpunkte",
    ar: "/nuqat-bitaqat-aitiman",
    az: "/kredit-karti-xallari",
    ru: "/bally-kreditnykh-kart",
  },
  [PATHS.API_SERVICE.PATH]: {
    tr: "/turna-api-hizmeti",
    de: "/turna-api-dienst",
    ar: "/khidmat-turna-api",
    az: "/turna-api-xidmeti",
    ru: "/servis-turna-api",
  },
  [PATHS.CONTACT.PATH]: {
    tr: "/iletisim",
    de: "/kontakt",
    ar: "/ittisal",
    az: "/elaqe",
    ru: "/kontakt",
  },
  [PATHS.SOCIAL_MEDIA_PERMISSIONS.PATH]: {
    tr: "/sosyal-medya-paylasim-izni",
    de: "/social-media-teilnahme-erlaubnis",
    ar: "/siyasat-sosyal-medya-tealuf",
    az: "/sosial-medya-paylasim-izni",
    ru: "/politika-sosialnykh-medii-podopisyvania",
  },
  [PATHS.PRIVACY_POLICY.PATH]: {
    tr: "/gizlilik-politikasi",
    de: "/datenschutzrichtlinie",
    ar: "/siyasat-khususia",
    az: "/mexfilik-siyaseti",
    ru: "/politika-konfidentsialnosti",
  },
  [PATHS.COOKIE_POLICY.PATH]: {
    tr: "/cerez-politikasi",
    de: "/cookie-richtlinie",
    ar: "/siyasat-kukirat",
    az: "/kuki-siyaseti",
    ru: "/politika-faylov-cookie",
  },
  [PATHS.TERMS_OF_USE.PATH]: {
    tr: "/kullanim-sartlari",
    de: "/nutzungsbedingungen",
    ar: "/shurut-istikhdam",
    az: "/istifade-sertleri",
    ru: "/usloviya-ispolzovaniya",
  },
  [PATHS.DATA_PROTECTION.PATH]: {
    tr: "/kisisel-verilerin-korunmasi",
    de: "/datenschutz",
    ar: "/himayat-bayanat-shakhsiya",
    az: "/sexsi-melumatlarin-qorunmasi",
    ru: "/zashchita-dannykh",
  },
  [PATHS.COMMERCIAL_MESSAGE_CONSENT.PATH]: {
    tr: "/ticari-elektronik-ileti-acik-riza-metni",
    de: "/kommerzielle-nachrichtenrichtlinie",
    ar: "/siyasat-risalat-tijariya",
    az: "/kommersiya-mesaji-siyaseti",
    ru: "/politika-kommercheskikh-soobshcheniy",
  },
  [PATHS.GUIDELINE.PATH]: {
    tr: "/kilavuz",
    de: "/anleitung",
    ar: "/dalil",
    az: "/telimat",
    ru: "/rukovodstvo",
  },
  [PATHS.DOWNLOAD.PATH]: {
    tr: "/indir",
    de: "/herunterladen",
    ar: "/tahmi",
    az: "/yukle",
    ru: "/zagruzit",
  },
  [PATHS.SMART_FLIGHT_TICKET.PATH]: {
    tr: `/tum-hizmetlerimiz?advantage=akilli-ucus`,
    de: "/alle-dienstleistungen?advantage=akilli-ucus",
    ar: "/jami-khidamatuna?advantage=akilli-ucus",
    az: "/butun-xidmetlerimiz?advantage=akilli-ucus",
    ru: "/vse-uslugi?advantage=akilli-ucus",
  },
  [PATHS.ADVANTAGES.PATH]: {
    tr: "/tum-hizmetlerimiz",
    de: "/alle-dienstleistungen",
    ar: "/jami-khidamatuna",
    az: "/butun-xidmetlerimiz",
    ru: "/vse-uslugi",
  },
  [PATHS.ONLINE_CHANGE_SERVICE.PATH]: {
    tr: "/online-degisiklik-hizmeti",
    de: "/online-anderungsservice",
    ar: "/khidmat-taghyir-online",
    az: "/online-deyisiklik-xidmeti",
    ru: "/servis-onlayn-izmeneniy",
  },
  [PATHS.UNCONDITIONAL_CANCELLATION_SERVICE.PATH]: {
    tr: "/kosulsuz-iptal-hizmeti",
    de: "/bedingungsloser-stornierungsservice",
    ar: "/khidmat-ilgha-ghayr-mashrut",
    az: "/sertsiz-legv-xidmeti",
    ru: "/bezuslovnyy-servis-otmeny",
  },
  [PATHS.FREE_LIVE_SUPPORT.PATH]: {
    tr: "/7-24-cagri-merkezi-hizmeti",
    de: "/24-7-anruf-service",
    ar: "/markaz-altawasul",
    az: "/7-24-cagri-merkezi-xidmeti",
    ru: "/podderzhka-24-7-khidmat-al-ma'lul",
  },

  [PATHS.FAQ_PAGE.PATH]: {
    tr: "/sikca-sorulan-sorular",
    de: "/haufig-gestellte-fragen",
    ar: "/as'ila-sha'i'a",
    az: "/tez-verilən-suallar",
    ru: "/chasto-zadavayemye-voprosy",
  },
  [PATHS.FAQ_CATEGORY_PAGE.PATH]: {
    tr: "/sikca-sorulan-sorular/[categorySlug]",
    de: "/haufig-gestellte-fragen/[categorySlug]",
    ar: "/as'ila-sha'i'a/[categorySlug]",
    az: "/tez-verilən-suallar/[categorySlug]",
    ru: "/chasto-zadavayemye-voprosy/[categorySlug]",
  },
  [PATHS.PUBLIC_HOLIDAYS_PAGE.PATH]: {
    tr: "/resmi-tatiller",
    de: "/gesetzliche-feiertage",
    ar: "/a'yad-rasmiya",
    az: "/resmi-bayramlar",
    ru: "/gosudarstvennyye-prazdniki",
  },
  [PATHS.INVITATION_REGISTER_PAGE.PATH]: {
    tr: "/davetiye/[InvitationCode]",
    de: "/einladung/[InvitationCode]",
    ar: "/da'wa/[InvitationCode]",
    az: "/devet/[InvitationCode]",
    ru: "/priglasheniye/[InvitationCode]",
  },
};
